import { faLanguage } from "@fortawesome/pro-regular-svg-icons";

import { AppRole } from "../../../@api";

import { FeatureCard } from "../../components/Pages";
import { createLazyRoleCheckGuard } from "../../components/Routes/Functions/createLazyRoleCheckGuard";
import { lazyRouteWithGuards } from "../../components/Routes/Functions/LazyRouteFunction";
import { translationKeys } from "../../models/app-translation-keys";
import { RouteConstants } from "../../models/enums";
import { IFeature } from "../iFeature";

const requiredRole = AppRole.TranslationFeature;

export const translationFeature: IFeature = {
  requiredRole,
  route: {
    path: RouteConstants.Translation,
    lazy: lazyRouteWithGuards({
      importer: () => import("./TranslationPage"),
      componentName: "TranslationPage",
      guards: [createLazyRoleCheckGuard(requiredRole)],
    }),
  },
  menuItem: {
    id: "translation",
    label: translationKeys.feature.translation.link,
    breadCrumbTitle: translationKeys.feature.translation.breadCrumbTitle,
    url: `/${[RouteConstants.Ai, RouteConstants.Translation].join("/")}`,
    path: RouteConstants.Translation,
    showFooter: true,
    hasSideBar: false,
    fontAwesomeIcon: faLanguage,
  },
  card: (
    <FeatureCard
      featureKey="translation"
      featureIcon={faLanguage}
      route={RouteConstants.Ai}
      featureRoute={RouteConstants.Translation}
    />
  ),
};
